import { defaultSliceSchema } from "~/components/slices/constants"

export const babackSliceSchema = defaultSliceSchema("baback").extend({
})
